import React, { useEffect } from 'react';
// import PropTypes from 'prop-types';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import { IntroGuideSection } from '../../organisms/category/introGuideSection/IntroGuideSection';
import { SystemList } from '../../organisms/category/systemList/SystemList';
import { InfoSection } from '../../organisms/category/infoSection/InfoSection';
import { CollapseSection } from '../../organisms/category/collapseSection/CollapseSection';
// import InfoPopup from '../../molecules/shared/infoPopup/InfoPopup';
import { getDataByType } from '../../../utils/utils';
import SystemGuideCard from '../../molecules/category/systemGuideCard/SystemGuideCard';
import SystemguideModal from '../../organisms/shared/systemguideModal/SystemguideModal';

const scrollCheck = (hasShowOverlay, setHasShowOverlay, setShowOverlay) => {
  const pageHeight = document.documentElement.scrollHeight;
  const scrollPosition = window.scrollY;
  const scrollPercentage = (scrollPosition / pageHeight) * 100;
  if (!hasShowOverlay && scrollPercentage > 15) {
    setHasShowOverlay(true);
    setShowOverlay(true);
  }
};

export const Category = ({
  hero,
  breadcrumbs,
  sections,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  trackOutboundLink,
  showOverlay,
  setShowOverlay,
  hasShowOverlay,
  setHasShowOverlay,
}) => {
  const sectionOne = getDataByType(sections, 'sectionOne');
  const cardsData = getDataByType(sections, 'sectionSystemList');
  const sectionThree = getDataByType(sections, 'sectionThree');
  const sectionCollapse = getDataByType(sections, 'sectionAccordion');
  const sectionSystemguideModal = getDataByType(
    sections,
    'sectionSystemguideModal'
  );

  useEffect(() => {
    const scrollHandler = () =>
      scrollCheck(hasShowOverlay, setHasShowOverlay, setShowOverlay);
    window.addEventListener('scroll', scrollHandler);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setShowOverlay(false);
      }
    });
    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          setShowOverlay(false);
        }
      });
    };
  }, [hasShowOverlay, setHasShowOverlay, setShowOverlay]);

  const card = hero?.card ? (
    <div className="mt-12">
      <SystemGuideCard
        title={hero.card.title}
        description={hero.card.description}
        href={hero.card.url}
        icon={hero.card.icon}
        handleClick={hero.card.handleClick}
        label={hero.card.label}
        linkClassName="min-h-[160px]"
        buttonText={hero.card.buttonText}
      />
    </div>
  ) : null;

  return (
    <div className="bg-primary-50 overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header
        headerText={hero.title}
        minHeight="350px"
        card={card}
        isLargeWidth
      />
      <main className="relative">
        <Breadcrumbs
          levels={breadcrumbs}
          infoText={t('legal.category.text')}
          // infoContent={
          //   <InfoPopup
          //     description={t('legal.category.text')}
          //     displayDirection="left"
          //   />
          // }
        />
        <IntroGuideSection section={sectionOne} t={t} />
        <SystemList
          section={cardsData}
          showRelatedCategories
          showSubCategories
          showCta
          locale={locale}
          trackOutboundLink={trackOutboundLink}
          t={t}
        />
        <InfoSection section={sectionThree} />
        {sectionCollapse.componentData.length > 0 && (
          <CollapseSection section={sectionCollapse} />
        )}
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
      {showOverlay && <SystemguideModal section={sectionSystemguideModal} />}
    </div>
  );
};

Category.propTypes = {
  // hero: PropTypes.object,
  // sections: PropTypes.array,
};
